import { BindingCreator } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

export const BANK_NAME_FIELD_NAME = 'bankName';
const BANK_NAME_MAX_LENGTH = 50;

export type BankNameFormBeanPart = {
   [BANK_NAME_FIELD_NAME]: string;
};

type BankNameFieldProps = {
   readonly register: BindingCreator<BankNameFormBeanPart, typeof BANK_NAME_FIELD_NAME>;
};

export const BankNameField = (props: BankNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register(BANK_NAME_FIELD_NAME, {
            required: true,
            maxLength: BANK_NAME_MAX_LENGTH,
         })}
         testId={BANK_NAME_FIELD_NAME}
         label={invoiceSharedComponentsTranslationKeys.bankName.label}
         placeholder={invoiceSharedComponentsTranslationKeys.bankName.placeholder}
      />
   );
};
